// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powerbi-layout {
  display: flex;
  height: calc(100vh - 55px);
  position: relative;
  margin-top: 5px;
}
.powerbi-layout .powerbi-content {
  flex: 1 1;
  margin-left: 285px;
  transition: margin-left 0.3s ease;
  overflow-y: hidden;
  position: relative;
  z-index: 1;
}
.powerbi-layout .powerbi-content.menu-collapsed {
  margin-left: 60px;
}

@media (max-width: 768px) {
  .powerbi-layout {
    flex-direction: column;
    height: calc(100vh - 55px);
    margin-top: 8px;
  }
  .powerbi-layout .powerbi-content {
    margin-left: 0 !important;
    width: 100%;
    height: calc(100vh - 140px);
    overflow-y: auto;
  }
  .powerbi-layout.has-mobile-sticky-header {
    height: calc(100vh - 105px) !important;
    margin-top: 40px !important;
  }
  .powerbi-layout.has-mobile-sticky-header .powerbi-content {
    height: calc(100vh - 105px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/PowerBILayout.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AACJ;AACI;EACE,iBAAA;AACN;;AAKA;EACE;IACE,sBAAA;IAEA,0BAAA;IACA,eAAA;EAHF;EAKE;IACE,yBAAA;IACA,WAAA;IACA,2BAAA;IACA,gBAAA;EAHJ;EAOE;IACE,sCAAA;IACA,2BAAA;EALJ;EAOI;IACE,sCAAA;EALN;AACF","sourcesContent":[".powerbi-layout {\n  display: flex;\n  height: calc(100vh - 55px);\n  position: relative;\n  margin-top:5px;\n\n  .powerbi-content {\n    flex: 1;\n    margin-left: 285px; // Default margin for expanded menu\n    transition: margin-left 0.3s ease;\n    overflow-y: hidden;\n    position: relative;\n    z-index: 1; // Keep content above background but below menu\n\n    &.menu-collapsed {\n      margin-left: 60px; // Collapsed menu width\n    }\n  }\n}\n\n// Mobile responsive adjustments\n@media (max-width: 768px) {\n  .powerbi-layout {\n    flex-direction: column;\n    //height: 100vh;\n    height:calc(100vh - 55px);\n    margin-top:8px;\n\n    .powerbi-content {\n      margin-left: 0 !important;\n      width: 100%;\n      height: calc(100vh - 140px);\n      overflow-y: auto;\n    }\n\n    // Adjust layout when mobile sticky header is visible\n    &.has-mobile-sticky-header {\n      height: calc(100vh - 105px) !important;\n      margin-top: 40px !important;\n\n      .powerbi-content {\n        height: calc(100vh - 105px) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
